module.exports = __webpack_public_path__ + "assets/img/SpinTel-Pillar-Page-Resource-w540.a55e5c9f.webp";